const headerConfig = {
  showCategories: true,
  categoryHoverDropdown: false,
};

export default headerConfig;
